import { render } from "./ResetPasswordPage.vue?vue&type=template&id=5b619882"
import script from "./ResetPasswordPage.vue?vue&type=script&lang=js"
export * from "./ResetPasswordPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__